import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EDeleteFavoriteActionTypes {
  Success = 'DELETE_FAVORITE/SUCCESS',
}

interface IPayload {
  offerId: number;
}

type TDeleteFavoriteSuccess = ITypedReduxAction<EDeleteFavoriteActionTypes.Success, IPayload>;

export type TDeleteFavorite = TDeleteFavoriteSuccess;

export const deleteFavoriteSuccess = actionGenerator<EDeleteFavoriteActionTypes.Success, IPayload>(
  EDeleteFavoriteActionTypes.Success,
);
